module.exports = __webpack_public_path__ + "img/5-evidence-summary.917cb58d.png";